import { call, put, select } from "redux-saga/effects";
import moment from "moment";
import api from "../../services/api";
import { Creators as ImportacoesActions } from "../ducks/importacoes";
import { Creators as ModalActions } from "../ducks/modal";
import { Creators as AlertActions } from "../ducks/alert";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as SuccessActions } from "../ducks/success";
import { Creators as LoadingActions } from "../ducks/loading";
import { Creators as PageActions } from "../ducks/pages";

export function* getListImportacoes() {
  try {
    yield put(LoadingActions.setLoading());
    const { page, rowsPerPage } = yield select(state => state.importacoes);
    const { data } = yield call(
      api.get,
      `/imports?page=${page + 1}&&per_page=${rowsPerPage}`
    );
    const { data: importacoes, total } = data;
    let importacoesPayload = [];
    importacoesPayload = importacoes
      .filter(importacao => importacao.user !== null)
      .map(importacao => ({
        id: importacao.id,
        created_at: moment(importacao.created_at).format("DD/MM/YYYY HH:mm:ss"),
        user: importacao.user.name,
        file_name: importacao.file_name,
        type: importacao.type === "update" ? `Atualização` : `Importação`,
        result: `<span class="td-color" style="background-color: #1ab394; color: #ffffff; margin-right: 1rem; font-weight: normal;">${
          importacao.total_success
        } ${
          importacao.type === "update" ? `atualizados` : `importados`
        }</span> <span class="td-color" style="background-color: #f86c6b; color: #ffffff; font-weight: normal;">${
          importacao.total_errors
        } erros</span>`
      }));
    const name = "Importações";
    const path = "importacoes";
    yield put(PageActions.setPage(name, path));
    yield put(
      ImportacoesActions.getListImportacoesSuccess(importacoesPayload, total)
    );
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getImportacoes({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { data } = yield call(api.get, `/imports/${payload.id}`);
    yield put(ImportacoesActions.getImportacoesSuccess(data));
    const { action } = yield select(state => state.importacoesStores);
    if (action === "EDIT" || action === "DETAIL") {
      yield put(ModalActions.open());
    } else {
      const title = "Aviso de exclusão";
      const body = `O cadastro "${data.name}" será excluido do sistema.`;
      yield put(AlertActions.openAlert(title, body));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editImportacoes({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.put, `/imports/${payload.id}`, payload);
    yield put(ImportacoesActions.getListImportacoes());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro editado com sucesso."));
    yield put(ImportacoesActions.getListImportacoesSelects());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
    yield put(LoadingActions.unsetLoading());
  }
}

export function* addImportacoes({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/imports`, payload);
    yield put(ImportacoesActions.searchImportacoes({}));
    yield put(ImportacoesActions.getListImportacoes());
    yield put(ModalActions.close());
    yield put(SuccessActions.openSuccess("Cadastro adicionado com sucesso."));
    yield put(ImportacoesActions.getListImportacoesSelects());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deleteImportacoes() {
  try {
    yield put(LoadingActions.setLoading());
    const { id } = yield select(state => state.importacoes.item);
    yield call(api.delete, `/imports/${id}`);
    yield put(ImportacoesActions.getListImportacoes());
    yield put(SuccessActions.openSuccess("Cadastro excluído com sucesso."));
    yield put(ImportacoesActions.getListImportacoesSelects());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* searchImportacoes() {
  try {
    yield put(ImportacoesActions.getListImportacoes());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* getListImportacoesSelects() {
  try {
    const { data: importacoes } = yield call(api.get, `/imports/select`);
    yield put(ImportacoesActions.getListImportacoesSuccessSelects(importacoes));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* deleteAllImportacoes({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.post, `/imports/destroy-many`, {
      imports_id: payload.selected
    });
    yield put(ImportacoesActions.getListImportacoes());
    yield put(SuccessActions.openSuccess("Cadastros excluídos com sucesso."));
    yield put(ImportacoesActions.getListImportacoesSelects());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/importacoes.js